module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.menuOptions
    },
    on: {
      "change": _vm.changeMenu
    },
    model: {
      value: (_vm.currentOption),
      callback: function($$v) {
        _vm.currentOption = $$v
      },
      expression: "currentOption"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e7a5e2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 602
// module chunks = 2